<script>
	import { navigate } from "svelte-routing";

	export let row = {};
	export let key = "";
	export let linkBy = "";
	export let linkTo = "";

	$: targetId = row[linkBy || key];

	function handleClick(event) {
		if (!targetId) return;
		event.stopPropagation();
		navigate(`${linkTo}${targetId}`);
	}
</script>

{#if targetId}
	<button
		type="button"
		class="link link-text link-button"
		on:click={handleClick}
	>
		{row[key]}
	</button>
{:else}
	{row[key] || "-"}
{/if}

<style>
	.link-button {
		background: none;
		border: none;
		padding: 0;
		font: inherit;
		text-align: inherit;
		cursor: pointer;
	}
</style>
